import { render, staticRenderFns } from "./WorkComposite.vue?vue&type=template&id=50f8107e"
import script from "./WorkComposite.vue?vue&type=script&lang=ts"
export * from "./WorkComposite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports